import type {TGamePlayer} from '@kapitalist/contract/types'
import ConcealedGamePlayer from '~/models/game/GamePlayers/ConcealedGamePlayer'
import type ConcealedHand from '~/models/game/Hands/ConcealedHand'
import type Portfolio from '~/models/game/Portfolio'

/*
  "other" players at the table when the currently-logged-in user is playing
  this isn't used when viewing as a spectator, `SpectatorGamePosition` just keeps
  a list of Concealed... and ExposedPlayers.
*/
export default class OpponentGamePlayer extends ConcealedGamePlayer {
  constructor(playerData: TGamePlayer, portfolio: Portfolio, hand: ConcealedHand) {
    super(playerData, portfolio, hand)
  }
}
